import moment from 'moment';
import { dispatch, useReframe } from 'nike-re-framejs';
import React, { memo, useEffect } from 'react';

import { fireGAEvent } from '@/analytics';
import EmptyState from 'nike-ui/src/components/empty-state/EmptyState';
import i18n from '@i18n';
import MessageIcon from '@/icons/MessageIcon';
import { navigate } from '@/routing';
import { MESSAGE } from '@/routing/routes';
import BlockLoader from '@/ui/BlockLoader';
import { loadAccountMessages } from '@/message/handlers';
import { accountMessages$ } from '@/message/subs';

function AccountMessage({ data }) {
    const { annotation, created, id, state, subject } = data;

    function goToDetail() {
        fireGAEvent('Spravy', 'Otvorit spravu');
        navigate(MESSAGE, { spravaId: id });
    }

    return (
        <div className="message" onClick={goToDetail}>
            <h3 className={state === 'NEW' ? 'new' : ''}>{subject}</h3>
            <p>{annotation}</p>
            <div className="message-info">
                <span className="date">{formatMessageTime(created)}</span>
                {state === 'NEW' ? <span className="message-new">{i18n('jsp.niketv.new')}</span> : null}
            </div>
        </div>
    );
}

function formatMessageTime(messageTime) {
    if (moment.duration(moment().diff(messageTime)).asHours() < 24) {
        return moment(messageTime).fromNow();
    }
    return moment(messageTime).format('DD.MM.YYYY hh:mm:ss');
}

function AccountMessages() {
    useEffect(() => dispatch(loadAccountMessages()), []);

    const { subscribe } = useReframe();
    const messages = subscribe(accountMessages$);

    if (!messages) {
        return <BlockLoader />;
    }
    if (!messages.length) {
        const stateIcon = <MessageIcon width={60} height={60} fill="#aab2bd" />;
        return <EmptyState stateIcon={stateIcon} text={i18n('react.account.userMessages.none')} />;
    }
    const monthAgo =
        moment()
            .subtract(1, 'month')
            .unix() * 1000;
    const { lastMonthMsgs, olderMsgs } = messages.reduce(
        (ret, m) => {
            const target = m.created > monthAgo ? ret.lastMonthMsgs : ret.olderMsgs;
            target.push(m);
            return ret;
        },
        { lastMonthMsgs: [], olderMsgs: [] }
    );
    return (
        <div className="user-section-messages">
            {lastMonthMsgs.length ? (
                <div className="messages-section">
                    <h2>{i18n('react.account.userMessages.lastMonth')}</h2>
                    {lastMonthMsgs.map(msg => (
                        <AccountMessage key={msg.id} data={msg} />
                    ))}
                </div>
            ) : null}
            {olderMsgs.length ? (
                <div className="messages-section">
                    <h2>{i18n('react.account.userMessages.older')}</h2>
                    {olderMsgs.map(msg => (
                        <AccountMessage key={msg.id} data={msg} />
                    ))}
                </div>
            ) : null}
        </div>
    );
}

export default memo(AccountMessages);
